// ===== Interfaces =====

import {
    IAudioClipRefData,
}                           from '../interfaces';

// ===== Enums =====

import {
    AUDIO_PRELOAD_MODE,
}                           from '../enums';

/**
 * Lazily allocates one UI audio clip per ref so mounted controls do not each
 * consume a browser media player before the user interacts with them.
 *
 * This is the low-level allocation primitive shared by both:
 * - callback-driven editor helpers that only need "get me a clip now"
 * - the `useLazyAudioRef` hook that layers React config updates on top
 */
const getOrCreateAudioClip = (data: IAudioClipRefData): HTMLAudioElement => {
    const {
        audioRef,
        src = '',
        volume = 1,
        loop = false,
        preload = AUDIO_PRELOAD_MODE.auto,
    } = data;

    if (!audioRef.current) {
        const audioClip = new Audio();
        audioClip.src = src;
        audioClip.volume = volume;
        audioClip.loop = loop;
        audioClip.preload = preload;
        audioRef.current = audioClip;
    }

    return audioRef.current;
};

export default getOrCreateAudioClip;
